import React, { useEffect } from "react";
import Breadcrumb from "../../components/Reusable/Breadcrumb";
import { useDispatch, useSelector } from "react-redux";
import { fetchPromotionList } from "../../actions/promotion";
import { formatDate } from "../../utils";
import { Link } from "react-router-dom";
import InfoBox from "../../components/Reusable/InfoBox";
import { t } from "i18next"; // Import t function for translation

const Promotion = () => {
  const dispatch = useDispatch();
  const { promotionList } = useSelector((state) => state.promotionReducer);

  useEffect(() => {
    dispatch(fetchPromotionList());
  }, [dispatch]);

  return (
    <div className="promotion-main-container">
      <Breadcrumb title={t("promotion.breadcrumbTitle")} returnPage="/" />

      <div className="promotion-list-container">
        {promotionList?.length > 0 ? (
          promotionList?.map((promotion, key) => (
            <div className="promotion-list-item-holder">
              <Link to={`/promotion-detail/${promotion?.id}`} key={key}>
                <div className="promotion-list-item" key={key}>
                  <div className="promotion-list-item-image">
                    <img
                      src={promotion?.banner}
                      className="img-fluid"
                      alt="LG"
                    />
                  </div>
                  <div className="promotion-list-item-context">
                    <div className="promotion-date-content d-flex justify-content-between align-items-center">
                      <div className="promotion-list-item-date">
                        {t("promotion.validFrom")}:{" "}
                        {formatDate(promotion?.startDate)}
                      </div>
                      <div className="promotion-list-item-date">
                        {t("promotion.validTo")}:{" "}
                        {formatDate(promotion?.endDate)}
                      </div>
                    </div>
                    <div className="promotion-list-item-title">
                      {promotion?.name}
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))
        ) : (
          <InfoBox text={t("promotion.noPromotions")} />
        )}
      </div>
    </div>
  );
};

export default Promotion;
